// extracted by mini-css-extract-plugin
export default {"headerLinkBlock":"headerLinkBlock-GXz9q","removeLink":"removeLink-s3ygo","cancelButton":"cancelButton-WoJHj"};